import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { SessionService } from '../services/session.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private router: Router,
    private sessionService: SessionService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request).pipe(
      // Note: Idle timer resets are handled by user interactions only (mouse, keyboard, touch)
      // Background API calls should NOT reset the idle timer, otherwise users will never be logged out for inactivity
      catchError((error: HttpErrorResponse) => {
        // Handle 401 Unauthorized errors
        if (error.status === 401) {
          this.handle401Error(error);
        }
        return throwError(() => error);
      })
    );
  }

  /**
   * Handle 401 Unauthorized errors
   */
  private handle401Error(error: HttpErrorResponse): void {
    const errorData = error.error;

    // Check if the error includes an action directive
    if (errorData && errorData.action === 'logout') {
      this.performLogout(errorData);
    }
  }

  /**
   * Perform logout and redirect to appropriate login page
   */
  private performLogout(errorData: any): void {
    // Determine message to show user
    let message = 'Your session has expired';

    if (errorData.reason === 'token_expired') {
      message = 'Your session has expired';
    } else if (errorData.message) {
      message = errorData.message;
    }

    // Stop session monitoring
    this.sessionService.stopSession();

    // Store logout message for display on login page
    sessionStorage.setItem('session_timeout_message', message);

    // Determine user type for redirect
    const userType = localStorage.getItem('endUserType');

    // Clear all local storage
    localStorage.clear();
    sessionStorage.setItem('session_timeout_message', message); // Re-set after clear

    // Determine login path based on user type
    let loginPath = '/auth/login';
    if (userType === 'specialist') {
      loginPath = '/auth/specialist/login';
    } else if (userType === 'pcv' || userType === 'vc') {
      loginPath = '/auth/pcv/login';
    } else if (userType === 'admin') {
      loginPath = '/auth/admin/login';
    }

    // Navigate to login page
    this.router.navigate([loginPath]);
  }
}
